export default function userBehaviorColumns(Vue) {
  return [
    {
      title: "时间",
      key: "createTime",
      minWidth: 120,
      align: 'center'
    },
    {
      title: "行为类型",
      key: "actionType",
      align: 'center',
      minWidth: 200
    },
    {
      title: "行为名称",
      key: "eventName",
      minWidth: 200,
      align: 'center'
    },
    {
      title: "型号",
      key: "osVersion",
      align: 'center',
      minWidth: 100
    },
    {
      title: "版本号",
      key: "appVersion",
      align: 'center',
      minWidth: 80
    },
    {
      title: "ip",
      key: "loginIp",
      align: 'center',
      minWidth: 120,
      render: (h, { row }) => {
        return h('span', {
          style: {
            color: '#3091FF'
          },
          on: {
            click: () => {
              Vue.querySameIpDeviceMemberList(row.loginIp, null)
            }
          }
        }, row.loginIp)
      }
    },
    {
      title: "ip城市",
      key: "loginIp",
      align: 'center',
      minWidth: 120,
      render: (h, { row }) => {
        return row.loginIp
          ? h('span', {
            style: {
              color: '#3091FF'
            },
            on: {
              click: () => {
                window.open("https://www.ip138.com/iplookup.php?ip=" + row.loginIp + "&action=2", '_blank')
              }
            }
          }, '查看')
          : null
      }
    },
    {
      title: "deviceId",
      key: "deviceId",
      align: 'center',
      minWidth: 150,
      render: (h, { row }) => {
        return h('span', {
          style: {
            color: '#3091FF'
          },
          on: {
            click: () => {
              Vue.querySameIpDeviceMemberList(null, row.deviceId)
            }
          }
        }, row.deviceId)
      }
    }
  ]
}
